import React from "react";
import { Select, SelectProps } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function CustomSelect(props: SelectProps) {
  return <Select {...props} IconComponent={ExpandMoreIcon} />;
}
